// extracted by mini-css-extract-plugin
module.exports = {"btn_remove":"Section_btn_remove__1nqVd","btn_add":"Section_btn_add__1a-uG","group_btn":"Section_group_btn__14Tfy","field":"Section_field__nkE_c"};